/* eslint-disable no-underscore-dangle */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import React from 'react';
import Loadable from 'react-loadable';
import { Route, Switch } from 'react-router-dom';
import { connectedRouterRedirect } from 'redux-auth-wrapper/history4/redirect';
import locationHelperBuilder from 'redux-auth-wrapper/history4/locationHelper';
import LogIn from '../LogIn/index';
import CompanyLoader from './CompanyLoader';
import { Loading as Loaded, toulouseSchools } from '../../helpers/utils';
import Layout from '../Layout/index';
import PlacementTest from '../PlacementTest/index';
import PlacementTestOtherLanguage from '../StudentEWComponents/PlacementTestOtherLanguage/index';
import StudentEWCoursePlans from '../StudentEWComponents/CoursePlans/index';
import StudentEWReports from '../StudentEWComponents/Reports/index';
import ForgotPassword from '../LogIn/components/ForgotPassword';
import NewForgotPasswordForm from '../LogIn/components/NewForgotPassword';
import ResetPasswordPage from '../LogIn/components/ResetPasswordPage';
// import CompanyInfo from '../Company/index';

const locationHelper = locationHelperBuilder({});

function Loading(props) {
  if (props.error) {
    return (
      <div>
        Error!
        {' '}
        <button type="button" onClick={props.retry}>Retry</button>
      </div>
    );
  } if (props.pastDelay) {
    return <Loaded />;
  }
  return null;
}

const userIsNotAuthenticated = connectedRouterRedirect({
  // This sends the user either to the query param route if we have one,
  // or to the landing page if none is specified and the user is already logged in
  redirectPath: (state, ownProps) => locationHelper.getRedirectQueryParam(ownProps) || '/home',
  allowRedirectBack: false,
  authenticatedSelector: (state) => state.authentication.loggedIn !== true,
  wrapperDisplayName: 'UserIsNotAuthenticated',
});

const userIsAuthenticated = connectedRouterRedirect({
  redirectPath: '/',
  authenticatedSelector: (state) => state.authentication.loggedIn === true && state.user !== undefined,
  wrapperDisplayName: 'UserIsAuthenticated',
});

// const userIsValidated = connectedRouterRedirect({
//   redirectPath: '/information',
//   authenticatedSelector: (state) => state.infoSheet.infoSheet.status === 'validated'
//     || state.infoSheet.infoSheet.status === null,
//   wrapperDisplayName: 'UserIsValidated',
// });

const userIsStudent = connectedRouterRedirect({
  redirectPath: '/',
  authenticatedSelector: (state) => state.user.user.type === 4,
  wrapperDisplayName: 'userIsStudent',
});

const userIsTeacher = connectedRouterRedirect({
  redirectPath: '/',
  authenticatedSelector: (state) => state.user.user.type === 3,
  wrapperDisplayName: 'userIsTeacher',
});

const userIsMWTeacher = connectedRouterRedirect({
  redirectPath: '/',
  authenticatedSelector: (state) => state.user.user.type === 3 && state.user.user.isEW === false,
  wrapperDisplayName: 'userIsMWTeacher',
});

const isCompanyDefine = connectedRouterRedirect({
  redirectPath: (state, ownProps) => locationHelper.getRedirectQueryParam(ownProps) || '/home',
  // eslint-disable-next-line no-prototype-builtins
  authenticatedSelector: (state) => state.company.hasOwnProperty('company'),
  wrapperDisplayName: 'CompanyIsnotDefine',
});

const isCompanyDefinedAndNotToulouse = connectedRouterRedirect({
  redirectPath: (state, ownProps) => locationHelper.getRedirectQueryParam(ownProps) || '/home',
  // eslint-disable-next-line no-prototype-builtins
  authenticatedSelector: (state) => state.company.hasOwnProperty('company') && !toulouseSchools.includes(state.company.company._id),
  wrapperDisplayName: 'CompanyIsnotDefine',
});

const Replay = Loadable({
  loader: () => import('../Webinaires/Replay/index'),
  loading: Loading,
});

const InComming = Loadable({
  loader: () => import('../Webinaires/InComming/index'),
  loading: Loading,
});

const StudentList = Loadable({
  loader: () => import('../StudentList/index'),
  loading: Loading,
});

const Repeat = Loadable({
  loader: () => import('../Repeat/index'),
  loading: Loading,
});

const AdditionalTime = Loadable({
  loader: () => import('../AdditionalTime/index'),
  loading: Loading,
});

const Tutorials = Loadable({
  loader: () => import('../Tutorials/index'),
  loading: Loading,
});

const Elearning = Loadable({
  loader: () => import('../ELearning/components/DisplayCourse'),
  loading: Loading,
});

const DisplayModule = Loadable({
  loader: () => import('../ELearning/components/DisplayModule'),
  loading: Loading,
});

const DisplayModuleStudent = Loadable({
  loader: () => import('../StudentEWComponents/E-Learning/content/ELearning/components/DisplayModule'),
  loading: Loading,
});

const CatchUp = Loadable({
  loader: () => import('../CatchUp/index'),
  loading: Loading,
});

const Exports = Loadable({
  loader: () => import('../Exports/index'),
  loading: Loading,
});

const CatchUpDetails = Loadable({
  loader: () => import('../CatchUp/components/GroupDetails'),
  loading: Loading,
});

const Group = Loadable({
  loader: () => import('../Group/index'),
  loading: Loading,
});

const GroupEW = Loadable({
  loader: () => import('../CustomerEWComponents/Group'),
  loading: Loading,
});

const Groups = Loadable({
  loader: () => import('../CustomerEWComponents/Groups/index'),
  loading: Loading,
});

const Resources = Loadable({
  loader: () => import('../Resources/index'),
  loading: Loading,
});

const ResourcesDetails = Loadable({
  loader: () => import('../Resources/components/GroupDetails'),
  loading: Loading,
});

const GroupDetails = Loadable({
  loader: () => import('../Group/components/GroupDetails'),
  loading: Loading,
});

const Student = Loadable({
  loader: () => import('../Student/index'),
  loading: Loading,
});

const Ponderation = Loadable({
  loader: () => import('../Ponderation/index'),
  loading: Loading,
});

const Informations = Loadable({
  loader: () => import('../PersonnalInformations/index'),
  loading: Loading,
});

const Home = Loadable({
  loader: () => import('../Home/index'),
  loading: Loading,
});

const Confirmation = Loadable({
  loader: () => import('../Confirmation/index'),
  loading: Loading,
});

const TestReview = Loadable({
  loader: () => import('../TestReview/index'),
  loading: Loading,
});

const SignUp = Loadable({
  loader: () => import('../SignUp/index'),
  loading: Loading,
});

const TeacherGroup = Loadable({
  loader: () => import('../TeacherComponents/TeacherGroups/index'),
  loading: Loading,
});

const CoursePlan = Loadable({
  loader: () => import('../TeacherComponents/BookSelect/CoursePlan'),
  loading: Loading,
});

const TeacherCalendar = Loadable({
  loader: () => import('../TeacherComponents/Calendar'),
  loading: Loading,
});

const Contact = Loadable({
  loader: () => import('../Contact'),
  loading: Loading,
});

const ContactTeacher = Loadable({
  loader: () => import('../TeacherComponents/Help'),
  loading: Loading,
});

const SessionDetails = Loadable({
  loader: () => import('../TeacherComponents/Calendar/components/SessionDetails'),
  loading: Loading,
});

const Signatures = Loadable({
  loader: () => import('../TeacherComponents/Signatures'),
  loading: Loading,
});

const Reports = Loadable({
  loader: () => import('../TeacherComponents/Reports'),
  loading: Loading,
});

const ReportsByGroup = Loadable({
  loader: () => import('../TeacherComponents/Reports/components/StudentReport'),
  loading: Loading,
});

const Exams = Loadable({
  loader: () => import('../TeacherComponents/Exams'),
  loading: Loading,
});

const Results = Loadable({
  loader: () => import('../TeacherComponents/Exams/components/Results'),
  loading: Loading,
});

const ExamResults = Loadable({
  loader: () => import('../ExamResults'),
  loading: Loading,
});

const ResultsForCustomer = Loadable({
  loader: () => import('../ExamResults/components/Results'),
  loading: Loading,
});

const ResultsQuizForCustomer = Loadable({
  loader: () => import('../ExamResults/components/ResultsQuiz'),
  loading: Loading,
});

const ResultsPlacementTest = Loadable({
  loader: () => import('../ExamResults/components/ResultsPlacementTest'),
  loading: Loading,
});

const CoursePlanCustomerEW = Loadable({
  loader: () => import('../CustomerEWComponents/CoursePlan'),
  loading: Loading,
});

const Course = Loadable({
  loader: () => import('../TeacherComponents/Signatures/components/Course'),
  loading: Loading,
});

const GroupsProposals = Loadable({
  loader: () => import('../CustomerEWComponents/GroupsProposals'),
  loading: Loading,
});

const StudentAgenda = Loadable({
  loader: () => import('../StudentEWComponents/Agenda'),
  loading: Loading,
});

const StudentAttendance = Loadable({
  loader: () => import('../StudentEWComponents/Attendance'),
  loading: Loading,
});

const StudentElearning = Loadable({
  loader: () => import('../StudentEWComponents/E-Learning'),
  loading: Loading,
});
const StudentElearningResults = Loadable({
  loader: () => import('../StudentEWComponents/E-Learning/results'),
  loading: Loading,
});

const StudentSession = Loadable({
  loader: () => import('../StudentEWComponents/Session'),
  loading: Loading,
});

const GroupsStudent = Loadable({
  loader: () => import('../StudentEWComponents/Groups'),
  loading: Loading,
});

const Students = Loadable({
  loader: () => import('../CustomerEWComponents/Students'),
  loading: Loading,
});

const StudentEW = Loadable({
  loader: () => import('../CustomerEWComponents/Students/components/Student'),
  loading: Loading,
});

const CoursePlanList = Loadable({
  loader: () => import('../CustomerEWComponents/CoursePlanList'),
  loading: Loading,
});

const CoursePlanWrapper = Loadable({
  loader: () => import('../CustomerEWComponents/CoursePlanList/components/CoursePlanWrapper'),
  loading: Loading,
});

const SubGroupsResults = Loadable({
  loader: () => import('../SubGroups/GroupDetails'),
  loading: Loading,
});

const SubGroups = Loadable({
  loader: () => import('../SubGroups/index'),
  loading: Loading,
});

const ReportsList = Loadable({
  loader: () => import('../CustomerEWComponents/ReportsList'),
  loading: Loading,
});

const AdminInfos = Loadable({
  loader: () => import('../CustomerEWComponents/AdminInfos'),
  loading: Loading,
});

const Survey = Loadable({
  loader: () => import('../CustomerEWComponents/Survey'),
  loading: Loading,
});

const ResourcesTeacher = Loadable({
  loader: () => import('../TeacherComponents/Resources'),
  loading: Loading,
});

const ArchivesNotificationsStudent = Loadable({
  loader: () => import('../StudentEWComponents/Archives/Notifications'),
  loading: Loading,
});

const ArchivesAttendanceStudent = Loadable({
  loader: () => import('../StudentEWComponents/Archives/Attendance'),
  loading: Loading,
});

const ArchivesNotificationsTeacher = Loadable({
  loader: () => import('../TeacherComponents/Archives/Notifications'),
  loading: Loading,
});
const ArchivesReportsTeacher = Loadable({
  loader: () => import('../TeacherComponents/Archives/Reports'),
  loading: Loading,
});

const ArchivesNotificationsCompanyEW = Loadable({
  loader: () => import('../CustomerEWComponents/Archives/Notifications'),
  loading: Loading,
});

const Documents = Loadable({
  loader: () => import('../../shared/components/Documents'),
  loading: Loading,
});

const wrappedRoutes = () => (
  <Layout>
    <CompanyLoader>
      <Route exact path="/webinaires/replay" component={Replay} />
      <Route exact path="/webinaires/incomming" component={InComming} />
      <Route path="/confirmation" component={userIsStudent(Confirmation)} />
      <Route exact path="/home" component={Home} />
      <Route exact path="/repeat" component={Repeat} />
      <Route exact path="/additionalTime" component={AdditionalTime} />
      <Route exact path="/placementtest" component={userIsStudent(PlacementTest)} />
      <Route exact path="/placementtest/other" component={userIsStudent(PlacementTestOtherLanguage)} />
      <Route exact path="/teacher/groups" component={userIsTeacher(TeacherGroup)} />
      <Route exact path="/teacher/courseplan" component={userIsTeacher(CoursePlan)} />
      <Route exact path="/help" component={Contact} />
      <Route exact path="/teacher/calendar" component={userIsTeacher(TeacherCalendar)} />
      <Route exact path="/teacher/session/details" component={userIsTeacher(SessionDetails)} />
      <Route exact path="/teacher/signatures" component={userIsTeacher(Signatures)} />
      <Route exact path="/teacher/signatures/:courseId" component={userIsTeacher(Course)} />
      <Route exact path="/teacher/reports" component={userIsTeacher(Reports)} />
      <Route exact path="/teacher/reports/student" component={userIsTeacher(ReportsByGroup)} />
      <Route exact path="/teacher/exams" component={userIsTeacher(Exams)} />
      <Route exact path="/teacher/exams/results/:groupId1/:groupId2/:examId" component={userIsTeacher(Results)} />
      <Route exact path="/teacher/resources" component={userIsMWTeacher(ResourcesTeacher)} />
      <Route exact path="/teacher/contact" component={userIsTeacher(ContactTeacher)} />
      <Route exact path="/teacher/archives/notifications" component={userIsTeacher(ArchivesNotificationsTeacher)} />
      <Route exact path="/teacher/archives/reports" component={userIsTeacher(ArchivesReportsTeacher)} />
      <Route exact path="/test" component={StudentList} />
      <Route exact path="/exports" component={Exports} />
      <Route exact path="/customer/informations" component={AdminInfos} />
      <Route exact path="/documents" component={Documents} />
      <Route exact path="/customer/courseplan" component={CoursePlanCustomerEW} />
      <Route exact path="/customer/list/reports" component={ReportsList} />
      <Route exact path="/customer/list/courseplan" component={CoursePlanList} />
      <Route exact path="/customer/survey" component={Survey} />
      <Route exact path="/customer/single/courseplan" component={CoursePlanWrapper} />
      <Route exact path="/customer/proposals" component={GroupsProposals} />
      <Route exact path="/customer/group/:groupId" component={GroupEW} />
      <Route exact path="/customer/students" component={Students} />
      <Route exact path="/customer/student/:studentId" component={StudentEW} />
      <Route exact path="/customer/archives/notifications" component={ArchivesNotificationsCompanyEW} />
      <Route exact path="/courseplan/student" component={StudentEWCoursePlans} />
      <Route exact path="/agenda/student" component={StudentAgenda} />
      <Route exact path="/groups/student" component={GroupsStudent} />
      <Route exact path="/report/student" component={StudentEWReports} />
      <Route exact path="/archives/student/notifications" component={ArchivesNotificationsStudent} />
      <Route exact path="/archives/student/attendance" component={ArchivesAttendanceStudent} />
      <Route exact path="/attendance/student" component={StudentAttendance} />
      <Route exact path="/subgroups/results/:subgroupId" component={SubGroupsResults} />
      <Route exact path="/subgroups" component={SubGroups} />
      <Route exact path="/e-learning/student" component={StudentElearning} />
      <Route exact path="/e-learning/results" component={StudentElearningResults} />
      <Route exact path="/e-learning/course/:moduleID" component={DisplayModuleStudent} />
      <Route exact path="/session/student/:sessionId" component={StudentSession} />
      <Route exact path="/group" component={isCompanyDefine(Group)} />
      <Route exact path="/resources" component={isCompanyDefine(Resources)} />
      <Route exact path="/resources/:groupId" component={isCompanyDefine(ResourcesDetails)} />
      <Route exact path="/elearning" component={isCompanyDefine(Group)} />
      <Route exact path="/results" component={isCompanyDefine(ExamResults)} />
      <Route exact path="/exam/results/:grpLvl1/:grpLvl2/:semester/:activityId" component={isCompanyDefine(ResultsForCustomer)} />
      <Route exact path="/exam/results/quiz/:grpLvl1/:grpLvl2/:semester/:activityId/:_id" component={isCompanyDefine(ResultsQuizForCustomer)} />
      <Route exact path="/exam/results/placement/:grpLvl1/:grpLvl2/:semester/:activityId/:_id" component={isCompanyDefine(ResultsPlacementTest)} />
      <Route exact path="/groups" component={isCompanyDefine(Groups)} />
      <Route exact path="/student/:studentId" component={isCompanyDefine(Student)} />
      <Route exact path="/group/:groupId" component={isCompanyDefine(GroupDetails)} />
      <Route exact path="/catchup" component={isCompanyDefine(CatchUp)} />
      <Route exact path="/catchup/:groupId" component={isCompanyDefine(CatchUpDetails)} />
      <Route exact path="/elearning/course/:moduleID" component={DisplayModule} />
      <Route exact path="/elearning/:groupId" component={isCompanyDefine(Elearning)} />
      <Route exact path="/test/review/:userId" component={isCompanyDefine(TestReview)} />
      <Route exact path="/informations" component={isCompanyDefinedAndNotToulouse(Informations)} />
      <Route exact path="/ponderation" component={isCompanyDefine(Ponderation)} />
      <Route exact path="/tutorials" component={isCompanyDefine(Tutorials)} />
      <Route exact path="/signup" component={isCompanyDefine(SignUp)} />
      <Route exact path="/forgot-password" component={ForgotPassword} />
      <Route exact path="/new-password/:token" component={NewForgotPasswordForm} />
      <Route path="/resetpassword" element={<ResetPasswordPage />} />
    </CompanyLoader>
  </Layout>
);

const Router = () => (
  <main>
    <Switch>
      <Route exact path="/resetpassword" component={ResetPasswordPage} />
      <Route exact path="/confirmation/" component={Confirmation} />
      <Route exact path="/signup" component={userIsNotAuthenticated(SignUp)} />
      <Route exact path="/" component={userIsNotAuthenticated(LogIn)} />
      <Route path="/" component={userIsAuthenticated(wrappedRoutes)} />
    </Switch>
  </main>
);

export default Router;
